export default "__VITE_ASSET__c706cb64__"